export const SUBSCRIPTION_STATE = {
  expired: 'EXPIRED',
};

export const SWAP_ITEM_ID = 'm-0-4';
